<template>
  <v-form>
    <v-dialog :value="show" persistent max-width="850">
      <v-card :loading="boxLoading" :disabled="boxLoading">
        <template slot="progress">
          <v-progress-linear
            color="produit"
            height="7"
            indeterminate
          ></v-progress-linear>
        </template>
        <v-card-title class="text-h5"> Ajout </v-card-title>
        <v-card-text v-show="!boxLoading">
          Indiquez la référence, les spécificités de la référence et les
          conditionnements.
          <v-text-field
            label="Référence"
            v-model="intitule"
            clearable
            required
            filled
            dense
            :error-messages="intituleErrors"
            @input="$v.intitule.$touch()"
            @blur="$v.intitule.$touch()"
          ></v-text-field>
          <div data-desc-ref>
            <v-textarea
              v-model="descriptif"
              label="Descriptif"
              hint="Uniquement les spécificités de la référence"
              persistent-hint
              rows="3"
              clearable
              filled
              :error-messages="descriptifErrors"
              @input="$v.descriptif.$touch()"
              @blur="$v.descriptif.$touch()"
            >
            </v-textarea>
          </div>
          <v-row dense>
            <v-col cols="1" class="pt-5">
              <reference-unite-conditionnement
                abreviation="UI"
              ></reference-unite-conditionnement>
            </v-col>
            <v-col cols="8">
              <v-select
                v-model="conditionnementEmploi"
                :items="cdtsPharmat"
                item-value="id"
                item-text="libelle"
                return-object
                hint="Conditionnement"
                required
                filled
                :error-messages="conditionnementEmploiErrors"
                @input="$v.conditionnementEmploi.$touch()"
                @blur="$v.conditionnementEmploi.$touch()"
              ></v-select>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="iudIdEmploi"
                label="IUD-ID"
                required
                filled
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="1" class="pt-5">
              <reference-unite-conditionnement
                abreviation="CDT"
              ></reference-unite-conditionnement>
            </v-col>
            <v-col cols="2">
              <v-text-field
                label="Quantité"
                v-model="quantiteEmploi"
                type="number"
                min="1"
                step="1"
                hint="Nombre d'UI"
                required
                filled
                :error-messages="quantiteEmploiErrors"
                @input="$v.quantiteEmploi.$touch()"
                @blur="$v.quantiteEmploi.$touch()"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="conditionnementProtege"
                :items="cdtsPharmat"
                item-value="id"
                item-text="libelle"
                return-object
                label="Conditionnement"
                required
                filled
                :error-messages="conditionnementProtegeErrors"
                @input="$v.conditionnementProtege.$touch()"
                @blur="$v.conditionnementProtege.$touch()"
              ></v-select>
            </v-col>
            <v-col cols="3">
              <v-text-field
                v-model="iudIdProtege"
                label="IUD-ID"
                required
                filled
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="1" class="pt-5">
              <reference-unite-conditionnement
                abreviation="QML"
              ></reference-unite-conditionnement>
            </v-col>
            <v-col cols="2">
              <v-text-field
                label="Quantité"
                v-model="quantiteCommande"
                type="number"
                min="1"
                step="1"
                hint="Nombre d'UI"
                required
                filled
                :error-messages="quantiteCommandeErrors"
                @input="$v.quantiteCommande.$touch()"
                @blur="$v.quantiteCommande.$touch()"
              ></v-text-field>
            </v-col>
            <v-col cols="9" class="pt-5">
              <em
                >La QML est à exprimer en nombre total d'UI (Unités
                Intègres).</em
              >
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            text
            @click="
              $emit('ok', {
                intitule,
                descriptif,
                quantiteEmploi,
                conditionnementEmploi: conditionnementEmploi.libelle,
                idConditionnementEmploi: conditionnementEmploi.id,
                quantiteProtege: 1,
                conditionnementProtege: conditionnementProtege.libelle,
                idConditionnementProtege: conditionnementProtege.id,
                quantiteCommande,
                conditionnementCommande: 'UNITE(S)',
                idConditionnementCommande: 1,
                iudIdEmploi,
                iudIdProtege,
              })
            "
            :disabled="!valid"
          >
            OK
          </v-btn>
          <v-btn color="error" text @click="$emit('cancel')"> Annuler </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import FournisseurService from "@/services/FournisseurService";
import ReferenceUniteConditionnement from "./ReferenceUniteConditionnement";
import {
  required,
  maxLength,
  minValue,
  numeric,
} from "vuelidate/lib/validators";
import { maxFileSize } from "@/validators/validators.js";

export default {
  name: "ProduitReferenceDialog",
  components: {
    ReferenceUniteConditionnement,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    editedRef: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      boxLoading: false,
      caracsLoading: false,
      cdtsPharmat: null,
      caracsPharmat: null,
      intitule: null,
      descriptif: null,
      conditionnementEmploi: null,
      conditionnementProtege: null,
      conditionnementCommande: 1,
      quantiteEmploi: null,
      quantiteProtege: 1,
      quantiteCommande: null,
      iudIdEmploi: null,
      iudIdProtege: null,
      articlesTrousse: null,
      caracteristiques: null,
    };
  },
  watch: {
    show() {
      if (this.boxLoading) return;
      this.boxLoading = true;
      //console.log("editedRef (in Dialog)", this.editedRef);

      Promise.all([
        FournisseurService.getConditionnements({ all: true }),
        FournisseurService.getCaracteristiques({ all: true }),
      ])
        .then((res) => {
          this.cdtsPharmat = res[0].data;
          this.caracsPharmat = res[1].data;
        })
        .catch((err) => {
          if (
            err.response &&
            err.response.status &&
            err.response.status == 401
          ) {
            this.$store.dispatch(
              "setErreur",
              new Error("Vous avez été déconnecté.e")
            );
            this.$router.replace({ name: "home" });
          } else {
            this.$store.dispatch("setErreur", err);
          }
        })
        .finally(() => {
          if (this.editedRef != null) {
            this.intitule = this.editedRef.intitule;
            this.descriptif = this.editedRef.descriptif;
            this.conditionnementEmploi = {
              libelle: this.editedRef.conditionnementEmploi,
              id: this.editedRef.idConditionnementEmploi,
            };
            this.quantiteEmploi = this.editedRef.quantiteEmploi;
            this.conditionnementProtege = {
              libelle: this.editedRef.conditionnementProtege,
              id: this.editedRef.idConditionnementProtege,
            };
            this.quantiteProtege = 1; //this.editedRef.quantiteProtege;
            this.conditionnementCommande = {
              libelle: this.editedRef.conditionnementCommande,
              id: this.editedRef.idConditionnementCommande,
            };
            this.quantiteCommande = this.editedRef.quantiteCommande;
            this.articlesTrousse = this.editedRef.articlesTrousse;
            this.caracteristiques = this.editedRef.caracteristiques;
            this.iudIdEmploi = this.editedRef.iudIdEmploi;
            this.iudIdProtege = this.editedRef.iudIdProtege;
          } else {
            this.intitule = null;
            this.descriptif = null;
            this.conditionnementEmploi = null;
            //this.idConditionnementEmploi = null;
            this.quantiteEmploi = null;
            this.conditionnementProtege = null;
            //this.idConditionnementProtege = null;
            //this.quantiteProtege = null;
            this.conditionnementCommande = null;
            //this.idConditionnementCommande = null;
            this.quantiteCommande = null;
            this.articlesTrousse = null;
            this.caracteristiques = null;
            this.iudIdEmploi = null;
            this.iudIdProtege = null;
            this.$v.$reset();
          }
          this.boxLoading = false;
        });
    },
  },
  computed: {
    valid() {
      return !this.$v.$invalid;
    },
    intituleErrors() {
      const errors = [];
      if (!this.$v.intitule.$dirty) return errors;
      !this.$v.intitule.required && errors.push("Obligatoire");
      return errors;
    },
    descriptifErrors() {
      const errors = [];
      if (!this.$v.descriptif.$dirty) return errors;
      !this.$v.descriptif.maxLength && errors.push("5000 caractères maximum");
      return errors;
    },
    conditionnementEmploiErrors() {
      const errors = [];
      if (!this.$v.conditionnementEmploi.$dirty) return errors;
      !this.$v.conditionnementEmploi.required && errors.push("Obligatoire");
      return errors;
    },
    conditionnementProtegeErrors() {
      const errors = [];
      if (!this.$v.conditionnementProtege.$dirty) return errors;
      !this.$v.conditionnementProtege.required && errors.push("Obligatoire");
      return errors;
    },
    // conditionnementCommandeErrors() {
    //   const errors = [];
    //   if (!this.$v.conditionnementCommande.$dirty) return errors;
    //   !this.$v.conditionnementCommande.required && errors.push("Obligatoire");
    //   return errors;
    // },
    quantiteEmploiErrors() {
      const errors = [];
      if (!this.$v.quantiteEmploi.$dirty) return errors;
      !this.$v.quantiteEmploi.required && errors.push("Obligatoire");
      !this.$v.quantiteEmploi.numeric && errors.push("Doit être un nombre");
      !this.$v.quantiteEmploi.minValue && errors.push("Quantité minimale: 1");
      return errors;
    },
    // quantiteProtegeErrors() {
    //   const errors = [];
    //   if (!this.$v.quantiteProtege.$dirty) return errors;
    //   !this.$v.quantiteProtege.required && errors.push("Obligatoire");
    //   !this.$v.quantiteProtege.numeric && errors.push("Doit être un nombre");
    //   !this.$v.quantiteProtege.minValue && errors.push("Quantité minimale: 1");
    //   return errors;
    // },
    quantiteCommandeErrors() {
      const errors = [];
      if (!this.$v.quantiteCommande.$dirty) return errors;
      !this.$v.quantiteCommande.required && errors.push("Obligatoire");
      !this.$v.quantiteCommande.numeric && errors.push("Doit être un nombre");
      !this.$v.quantiteCommande.minValue && errors.push("Quantité minimale: 1");
      return errors;
    },
    etiquetteErrors() {
      const errors = [];
      if (!this.$v.etiquette.$dirty) return errors;
      !this.$v.etiquette.maxFileSize && errors.push("Taille maximale: 500Ko");
      return errors;
    },
  },
  methods: {
    validate() {},
  },
  validations: {
    intitule: {
      required,
    },
    descriptif: {
      maxLength: maxLength(5000),
    },
    conditionnementEmploi: {
      required,
    },
    conditionnementProtege: {
      required,
    },
    // conditionnementCommande: {
    //   required,
    // },
    quantiteEmploi: {
      required,
      numeric,
      minValue: minValue(1),
    },
    // quantiteProtege: {
    //   required,
    //   numeric,
    //   minValue: minValue(1),
    // },
    quantiteCommande: {
      required,
      numeric,
      minValue: minValue(1),
    },
    etiquette: {
      maxFileSize: maxFileSize(500000),
    },
  },
};
</script>

<style lang="css">
[data-desc-ref] .v-messages__message {
  color: darkorange !important;
  /* color: var(--v-fournisseur-base) !important; */
}
</style>
